import React from "react";
import "./index.scss";
import { useTranslation } from "react-i18next";
import { CSpinner } from "@coreui/react";

function Preloader(props) {
  const { t } = useTranslation();

  return (
    <div className="preloader-block">
      <CSpinner size="md" color="primary" />

      {/* <div className="preloader-block__image">
        <svg
          width="21"
          height="21"
          viewBox="0 0 21 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20.125 10.5001C20.1244 12.3287 19.6029 14.1194 18.6215 15.6623C17.6402 17.2053 16.2395 18.4368 14.5836 19.2127C12.9278 19.9885 11.0851 20.2766 9.27145 20.0432C7.45777 19.8098 5.74811 19.0645 4.34262 17.8947L4.11862 18.1187C3.95456 18.2828 3.73204 18.375 3.5 18.3751C3.38497 18.3755 3.27104 18.3529 3.16487 18.3086C3.00502 18.2423 2.86841 18.1301 2.77231 17.9862C2.67622 17.8423 2.62495 17.6731 2.625 17.5001V15.7501C2.625 15.518 2.71718 15.2955 2.88128 15.1314C3.04537 14.9673 3.26793 14.8751 3.5 14.8751H5.25C5.42303 14.8751 5.59216 14.9265 5.73602 15.0226C5.87988 15.1188 5.992 15.2554 6.05821 15.4153C6.12442 15.5751 6.14175 15.751 6.10801 15.9207C6.07426 16.0905 5.99095 16.2463 5.86862 16.3687L5.58687 16.6505C6.98138 17.7637 8.71262 18.3704 10.497 18.3711C12.2814 18.3717 14.0131 17.7664 15.4084 16.6542C16.8038 15.542 17.7801 13.989 18.1773 12.2494C18.5746 10.5098 18.3693 8.68687 17.5951 7.07921C16.8209 5.47155 15.5237 4.17448 13.9159 3.40048C12.3082 2.62648 10.4852 2.42144 8.74567 2.81895C7.00614 3.21645 5.45318 4.19294 4.34118 5.58844C3.22918 6.98394 2.62408 8.71573 2.625 10.5001C2.62509 11.029 2.67785 11.5566 2.7825 12.0751C2.82891 12.3025 2.78308 12.5391 2.65508 12.7327C2.52709 12.9263 2.32742 13.0612 2.1 13.1076C1.87257 13.154 1.63603 13.1082 1.44239 12.9802C1.24876 12.8522 1.11391 12.6525 1.0675 12.4251C0.799899 11.1072 0.81142 9.74796 1.10131 8.43484C1.39121 7.12172 1.95304 5.88392 2.7506 4.80123C3.54816 3.71853 4.56374 2.81498 5.73187 2.14881C6.90001 1.48264 8.19477 1.06864 9.5327 0.933496C10.8706 0.798352 12.222 0.945063 13.4998 1.36417C14.7775 1.78328 15.9533 2.46549 16.9513 3.36681C17.9492 4.26814 18.7473 5.36858 19.2939 6.5972C19.8405 7.82582 20.1236 9.15536 20.125 10.5001ZM10.5 4.37509C10.2679 4.37509 10.0454 4.46728 9.88128 4.63137C9.71718 4.79547 9.625 5.01803 9.625 5.25009V10.5001C9.625 10.7322 9.71718 10.9547 9.88128 11.1188C10.0454 11.2829 10.2679 11.3751 10.5 11.3751H14.875C15.1071 11.3751 15.3296 11.2829 15.4937 11.1188C15.6578 10.9547 15.75 10.7322 15.75 10.5001C15.75 10.268 15.6578 10.0455 15.4937 9.88137C15.3296 9.71728 15.1071 9.62509 14.875 9.62509H11.375V5.25009C11.375 5.01803 11.2828 4.79547 11.1187 4.63137C10.9546 4.46728 10.7321 4.37509 10.5 4.37509Z"
            fill="black"
          />
        </svg>
      </div>
      <b>
        {t("preloader.text")}
        <div className="dots">
          <span>.</span>
          <span>.</span>
          <span>.</span>
        </div>
      </b> */}
    </div>
  );
}
export default Preloader;
